import { Component, OnDestroy, OnInit, HostListener, ElementRef, ViewChild } from '@angular/core';
import { DialogComponent, DialogService } from 'ngx-bootstrap-modal';
declare var $: any;

export interface DialogYesModel {
  title: string;
  message: any;
  elementId: any;
}

@Component({
  selector: 'app-dialog-yes',
  templateUrl: './dialog-yes.component.html'
})

export class DialogYesComponent extends DialogComponent<DialogYesModel, boolean> implements DialogYesModel, OnDestroy, OnInit {
  @ViewChild('buttonOk') buttonOk: ElementRef;
  title: string;
  message: any;
  elementId: any;

  constructor(dialogService: DialogService) {
    super(dialogService);
    setTimeout(() => {
      document.getElementById('buttonOk').focus();
    }, 10);
  }

  /**
   * 初期表示
   * */
  ngOnInit() {
    // 背面の固定
    $('body').css('overflow-y', 'hidden'); // 強化テストNo245
  }

  btnOk() {
    this.close(true);
    if (this.elementId != null) {
      setTimeout(() => {
        document.getElementById(this.elementId).focus();
      }, 200);
    }
  }

  ngOnDestroy() {
    // 背面の固定解除
    $('body').css('overflow-y', 'scroll'); // 強化テストNo245

    this.close(false);
    if (this.elementId != null) {
      setTimeout(() => {
        document.getElementById(this.elementId).focus();
      }, 200);
    }
  }

  @HostListener('window:keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    // Tabキーの場合
    if (event.keyCode == 9) {
      this.buttonOk.nativeElement.focus();
      return false;
    }
    // 十字キーの場合
    if (event.keyCode == 37 || event.keyCode == 38 || event.keyCode == 39 || event.keyCode == 40) {
      this.buttonOk.nativeElement.focus();
      return false;
    }
    // ENTERキーの場合
    if (event.keyCode == 13) {
      this.btnOk();
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/component/dialog-yes/dialog-yes.component.ts